import React from 'react';
import { FaCheck, FaClock, FaUsers, FaTag, FaCrown, FaShieldAlt } from 'react-icons/fa';
import Card from './Card';

const OptionSelection = ({ 
  activityOptions, 
  selectedOption, 
  handleOptionSelect,
  selectedCountry 
}) => {
  const features = [
    { icon: FaClock, label: 'Flexible Duration' },
    { icon: FaUsers, label: 'Group Discounts' },
    { icon: FaShieldAlt, label: 'Insurance Included' },
    { icon: FaCrown, label: 'Premium Experience' },
  ];

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {features.map((feature, index) => (
          <div key={index} className="bg-gradient-to-br from-blue-50 to-purple-50 p-4 rounded-xl border border-blue-100">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                <feature.icon className="text-blue-600" />
              </div>
              <span className="text-sm font-medium text-gray-700">{feature.label}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {activityOptions.map((option, index) => (
          <Card
            key={option._id}
            selected={selectedOption?._id === option._id}
            onClick={() => handleOptionSelect(option)}
            className={index === 1 ? 'relative overflow-hidden' : ''}
          >
            {index === 1 && (
              <div className="absolute top-0 right-0 bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-4 py-1 rounded-bl-lg">
                <span className="text-xs font-bold">MOST POPULAR</span>
              </div>
            )}
            
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">
                    {option.name}
                  </h3>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm text-blue-600 font-medium">
                      {option.active ? 'Available' : 'Limited'}
                    </span>
                    {option.maxCapacity > 10 && (
                      <span className="text-xs px-2 py-1 bg-green-100 text-green-800 rounded-full">
                        Group Friendly
                      </span>
                    )}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold text-gray-900">
                    {selectedCountry?.currencySymbol || '$'}
                    {option.basePrice}
                  </div>
                  <div className="text-sm text-gray-500">per person</div>
                </div>
              </div>

              <div className="space-y-3 mb-6">
                <div className="flex items-center text-gray-600">
                  <FaClock className="mr-3 text-blue-500" />
                  <span>Duration: {option.duration} minutes</span>
                </div>
                <div className="flex items-center text-gray-600">
                  <FaUsers className="mr-3 text-green-500" />
                  <span>Max Capacity: {option.maxCapacity} people</span>
                </div>
                <div className="flex items-center text-gray-600">
                  <FaTag className="mr-3 text-purple-500" />
                  <span>Free cancellation within 24 hours</span>
                </div>
              </div>

              <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                <h4 className="font-medium text-gray-900 mb-2">What's Included</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li className="flex items-center">
                    <FaCheck className="text-green-500 mr-2" size={12} />
                    Professional guide
                  </li>
                  <li className="flex items-center">
                    <FaCheck className="text-green-500 mr-2" size={12} />
                    Equipment rental
                  </li>
                  <li className="flex items-center">
                    <FaCheck className="text-green-500 mr-2" size={12} />
                    Safety briefing
                  </li>
                </ul>
              </div>

              <div
                className={`w-full py-3.5 rounded-xl font-medium transition-all duration-300 flex items-center justify-center cursor-pointer
                  ${
                    selectedOption?._id === option._id
                      ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
              >
                {selectedOption?._id === option._id ? (
                  <>
                    <FaCheck className="mr-2" />
                    Selected - Continue to Visitors
                  </>
                ) : (
                  'Select Package'
                )}
              </div>
            </div>
          </Card>
        ))}
      </div>

      {activityOptions.length === 0 && (
        <div className="text-center py-12">
          <div className="text-gray-400 mb-4">
            <FaTag className="w-16 h-16 mx-auto opacity-50" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            No packages available
          </h3>
          <p className="text-gray-600">
            Please select a different activity
          </p>
        </div>
      )}
    </div>
  );
};

export default OptionSelection;